<template>
  <!--弹窗-->
  <el-dialog width="600px" :title="title" :visible.sync="visible" :before-close="handleClose">
      <div style="height: 250px !important;">
            <div class="top">
                <div style="font-weight: 900;">下载模板</div>
                <div style="margin-left: 140px;">
                    <a href="/export/关键词模板.xlsx" style="text-decoration: underline; color: rgb(58, 142, 230);">点击下载“关键词”模板</a>
                </div>
            </div>
            <div class="download">
                <el-upload
                    class="upload-demo"
                    drag
                    action="/"
                    :file-list="fileList"
                    :on-change="handleChange"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    multiple>
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <div class="el-upload__text" style="font-size: 12px;margin-top: 5px;">只能上传.xls/.xlsx文件</div>
                </el-upload>
            </div>
      </div>
    <el-row style="margin-top:17px; ">
      <el-button
        style="float:right;margin-left:6px;"
        size="mini"
        plain
        @click="handleClose(true)"
      >取 消</el-button>
      <el-button style="float:right" size="mini" type="primary" @click="addForm()" :loading="disabled">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import * as api from "@/api/Product/Product";
export default {
    data() {
        return {
            fileList: [],
            obj: {},
            disabled: false
        };
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ""
        },
        KeywordID: {
            type: String,
            default: ""
        }
    },
    methods: {
        //上传Excel文件的处理方法
        handleChange(file, fileList) {
            if (fileList.length > 1) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            this.fileTemp = file.raw;
            let extend = this.fileTemp.name.substring(
                this.fileTemp.name.lastIndexOf("."),
                this.fileTemp.name.length
            );
            if (this.fileTemp) {
                if (extend == ".xlsx" || extend == ".xls") {
                    this.importfxx(this.fileTemp);
                } else {
                    this.$message({
                        type: "warning",
                        message: "附件格式错误，请删除后重新上传!"
                    });
                }
            } else {
                this.$message({
                    type: "warning",
                    message: "请上传附件!"
                });
            }
        },
        //超过上载文件的最大数量限制如何删除文件
        handleRemove() {
            this.fileList = [];
            this.fileTemp = null;
            this.obj = {};
        },
        importfxx(obj) {
            const _this = this;
            // const inputDOM = this.$refs.inputer;
            // 通过DOM检索文件数据
            this.file = obj;
            var rABS = false; //通过DOMRead检索文件数据将文件作为二进制字符串读取
            var f = this.file;
            var reader = new FileReader();
            // if (!FileReader.prototype.readAsBinaryString) {
            FileReader.prototype.readAsBinaryString = function(f) {
                var binary = "";
                var rABS = false; //将文件作为二进制字符串读取
                // var pt = this;
                var wb; //读取完成的数据
                var outdata;
                var reader = new FileReader();
                reader.onload = function() {
                    var bytes = new Uint8Array(reader.result);
                    var length = bytes.byteLength;
                    for (var i = 0; i < length; i++) {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    //如果main.js中没有介绍，那么您需要在这里介绍它来解析excel
                    var XLSX = require("xlsx");
                    if (rABS) {
                        wb = XLSX.read(btoa(binary), {
                            //手动转换
                            type: "base64"
                        });
                    } else {
                        wb = XLSX.read(binary, {
                            type: "binary"
                        });
                    }
                    outdata = XLSX.utils.sheet_to_json(
                        wb.Sheets[wb.SheetNames[0]]
                    );
                    //数据可以在这里处理。
                    const arr = [];
                    outdata.map(v => {
                        arr.push(v["关键词"]);
                    });
                    _this.obj.keywords = arr;
                    return arr;
                };
                reader.readAsArrayBuffer(f);
            };
            if (rABS) {
                reader.readAsArrayBuffer(f);
            } else {
                reader.readAsBinaryString(f);
            }
        },
        addForm() {
            if (JSON.stringify(this.obj) == "{}") {
                this.$message({
                    type: "error",
                    message: "请上传符合格式数据(Excel)文件！"
                });
                return;
            }
            this.disabled = true;
            this.obj.id = this.KeywordID;
            api.put_keyword(this.obj)
                .then(res => {
                    if (res.code === 0) {
                        this.$message({
                            message: "批量添加成功",
                            type: "success"
                        });
                        this.disabled = false;
                        this.handleClose(false);
                    } else {
                        this.disabled = false;
                        this.$message({
                            message: res.message,
                            type: "error"
                        });
                    }
                })
                .catch(() => {
                    this.disabled = true;
                });
        },
        // 关闭弹窗
        handleClose(isshow) {
            this.handleRemove();
            this.$emit("close-callback", isshow);
            this.disabled = false;
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.download {
    display: flex;
    justify-content: center;
}
.top {
    margin: 0px auto;
    width: 60%;
    margin-bottom: 20px;
    display: flex;
}
</style>
